export const breadcrumb = {
  title: 'Phone numbers',
  number: {
    buy: 'Buy',
    index: 'List'
  }
};
